import React, { useEffect, useRef } from "react";

import "./cookie.scss";

const Cookie = () => {
    const cookieRef = useRef();
    const timer = useRef();

    useEffect(() => {
        timer.current = setTimeout(() => {
            cookieRef.current.classList.add("active");
        }, 2500);

        return () => {
            clearTimeout(timer);
        };
    }, []);

    const handleClickBtnCookie = () => {
        cookieRef.current.classList.remove("active");
    };

    return (
        <div ref={cookieRef} className="container cookie ">
            <div className="cookie__content">
                <div className="cookie__text">
                    <h4 className="textBox__title--mid">Cookies</h4>
                    <p>
                        This site uses cookies to offer you a better browsing
                        experience. Find out{" "}
                        <a
                            href="https://www.dosetoken.com/cookies.html"
                            target="_blank"
                            rel="noreferrer"
                        >
                            more
                        </a>{" "}
                        on how we use cookies and how you can change your
                        settings.
                    </p>
                </div>

                <div
                    className="btn btn__outline"
                    onClick={handleClickBtnCookie}
                >
                    I refuse cokkies
                </div>
                <div
                    className="btn btn__outline"
                    onClick={handleClickBtnCookie}
                >
                    I accept cookies
                </div>
            </div>
        </div>
    );
};

export default Cookie;
